import { AccountFilter } from '@pages/PromotionPage/Games/GamesEditModal/GamePromotionEditModal.types';
import { LOCALE } from '@stores/localeWeight';
import { IImage } from './IImage';

export enum GamesPromotionStatus {
  ACTIVE = 'active',
  PLANNED = 'planned',
  ENDED = 'ended',
  ERROR = 'error',
}

export default interface tagGame {
  id: number;
  name: string;
}

export interface IGamePromotionValue {
  id: number;
  name: string;
  image?: any;
}

export interface IPromotionGames {
  id: number;
  name: string;
  starts: string;
  ends: string;
  searchSource: string;
  game: IGamePromotionValue;
  status: GamesPromotionStatus;
  position: number;
  text: string;
  filter: {
    gameId?: number;
    ids: number[];
    languages: LOCALE | null;
    locales: LOCALE | 'all' | null | any;
    games: tagGame[];
  };
}

export interface IPromotionGamesAction {
  id?: number;
  name: string;
  starts?: string;
  ends?: string;
  position?: number;
  gameId?: any;
  accountFilter?: AccountFilter;
  searchSource?: string;
}
